import Theme from '~/constants/theme'

const UIMixin = {
  inject: ['theme'],

  computed: {
    isDarkTheme () {
      return this.theme && this.theme.color === Theme.Dark
    }
  }
}

export default UIMixin
